module.exports = __webpack_public_path__ + "media/app/google-play-badge-es-e39fdda3.svg";